import { useAction, useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { Button, InviteIcon } from '@blade/ui-kit'
import { Numeric } from '@blade/ui-kit'
import { nativeNetworkCurrencyAtom } from '@root/entities/currency'
import { RankCard } from '@root/entities/leaderboard/ui/desktop'
import { profileAtom } from '@root/entities/profile'
import { referralBalanceNativeAtom } from '@root/entities/referral'
import { ReferralLeaderboardTable } from '@root/features/leaderboard/ui/desktop'
import { openInviteReferralDialogAction } from '@root/features/referral/atoms'
import { useAppRoutes } from '@root/features/routing'
import { useTranslation } from '@root/shared/localization'

import { Board } from '../../common'
import { BoardTitle } from '../../common/board-title'

type ReferralsBoardProps = {}

export const ReferralLeaderboardBoard: React.FC<ReferralsBoardProps> = () => {
  const { t } = useTranslation()
  const { navigateToProfileIndex } = useAppRoutes()
  const openInviteReferralDialog = useAction(openInviteReferralDialogAction)

  const [profile] = useAtom(profileAtom)
  const [referralBalance] = useAtom(referralBalanceNativeAtom)
  const [nativeCurrency] = useAtom(nativeNetworkCurrencyAtom)
  const referralRank = profile?.referralRank

  return (
    <Board>
      <Header>
        <BoardTitle
          onBack={navigateToProfileIndex}
          title={t('referral.leaderboard')}
        />

        <Button
          iconLeft={<InviteIcon />}
          onClick={() => {
            openInviteReferralDialog()
          }}
          variant="solid"
          color="primary"
          size="xxs"
          radius="rounded"
        >
          {t('referral.invite_referral')}
        </Button>
        <End>
          <RankCard
            rank={referralRank}
            color="up"
            profit={
              <Numeric
                value={referralBalance ?? 0}
                preset="currency-amount-short"
                currency={nativeCurrency.ticker}
              />
            }
          />
        </End>
      </Header>
      <ReferralLeaderboardTable />
    </Board>
  )
}

const Header = styled.div`
  height: 42px;
  display: grid;
  align-items: center;
  padding-inline: 8px 16px;
  grid-template-columns: auto auto 1fr;
  gap: 16px;
`

const End = styled.div`
  justify-self: end;
`
